import { useEffect, useRef } from "react";
import { useAudio } from "../context/AudioContext";

const N = 64;

export default function Visualizer({ cover }) {
  const { getLevels, playing } = useAudio();
  const bars = useRef([]);
  const disc = useRef(null);
  const rot = useRef(0);
  const levels = useRef(getLevels);
  levels.current = getLevels;

  useEffect(() => {
    let raf;
    const loop = (t) => {
      const lv = levels.current();
      bars.current.forEach((b, i) => {
        if (!b) return;
        const v = lv ? lv[i % lv.length] / 255 : 0.08 + 0.05 * Math.sin(t / 700 + i * 0.5);
        b.setAttribute("y2", String(-(150 + v * 60)));
      });
      if (playing) rot.current += 0.12;
      if (disc.current) disc.current.style.transform = `rotate(${rot.current}deg)`;
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => cancelAnimationFrame(raf);
  }, [playing]);

  return (
    <div className="relative w-full aspect-square max-w-[560px] mx-auto" data-testid="listen-visualizer">
      <svg viewBox="-250 -250 500 500" className="absolute inset-0 w-full h-full">
        <circle r="238" fill="none" stroke="var(--line)" />
        <circle r="200" fill="none" stroke="var(--line)" strokeDasharray="2 6" className="spin-rev" />
        <line x1="-250" y1="0" x2="250" y2="0" stroke="var(--line)" />
        <line x1="0" y1="-250" x2="0" y2="250" stroke="var(--line)" />
        {Array.from({ length: N }).map((_, i) => (
          <line key={i} ref={(el) => (bars.current[i] = el)} x1="0" y1="-150" x2="0" y2="-160" stroke="var(--bone)" strokeWidth="1.4" transform={`rotate(${(360 / N) * i})`} />
        ))}
        {[0, 90, 180, 270].map((a) => (
          <text key={a} transform={`rotate(${a}) translate(0,-244)`} fill="var(--ash)" fontSize="9" textAnchor="middle" className="f-mono">{a}&deg;</text>
        ))}
      </svg>
      <div className="absolute inset-[22%] rounded-full overflow-hidden border border-[var(--line)]" ref={disc}>
        {cover && <img src={cover} alt="" className="w-full h-full object-cover grayscale contrast-125" />}
        <div className="absolute inset-0 m-auto w-3 h-3 rounded-full bg-[var(--signal)]" />
      </div>
    </div>
  );
}
